/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiNurseryManagerInventoryInCreateInventoryInPost } from '../fn/inventory-in/api-nursery-manager-inventory-in-create-inventory-in-post';
import { ApiNurseryManagerInventoryInCreateInventoryInPost$Params } from '../fn/inventory-in/api-nursery-manager-inventory-in-create-inventory-in-post';
import { apiNurseryManagerInventoryInCreateInventoryInPost$Plain } from '../fn/inventory-in/api-nursery-manager-inventory-in-create-inventory-in-post-plain';
import { ApiNurseryManagerInventoryInCreateInventoryInPost$Plain$Params } from '../fn/inventory-in/api-nursery-manager-inventory-in-create-inventory-in-post-plain';
import { apiNurseryManagerInventoryInDeleteInventoryInDelete } from '../fn/inventory-in/api-nursery-manager-inventory-in-delete-inventory-in-delete';
import { ApiNurseryManagerInventoryInDeleteInventoryInDelete$Params } from '../fn/inventory-in/api-nursery-manager-inventory-in-delete-inventory-in-delete';
import { apiNurseryManagerInventoryInDeleteInventoryInDelete$Plain } from '../fn/inventory-in/api-nursery-manager-inventory-in-delete-inventory-in-delete-plain';
import { ApiNurseryManagerInventoryInDeleteInventoryInDelete$Plain$Params } from '../fn/inventory-in/api-nursery-manager-inventory-in-delete-inventory-in-delete-plain';
import { apiNurseryManagerInventoryInGetInventoriesInPost } from '../fn/inventory-in/api-nursery-manager-inventory-in-get-inventories-in-post';
import { ApiNurseryManagerInventoryInGetInventoriesInPost$Params } from '../fn/inventory-in/api-nursery-manager-inventory-in-get-inventories-in-post';
import { apiNurseryManagerInventoryInGetInventoriesInPost$Plain } from '../fn/inventory-in/api-nursery-manager-inventory-in-get-inventories-in-post-plain';
import { ApiNurseryManagerInventoryInGetInventoriesInPost$Plain$Params } from '../fn/inventory-in/api-nursery-manager-inventory-in-get-inventories-in-post-plain';
import { apiNurseryManagerInventoryInGetInventoryInPost } from '../fn/inventory-in/api-nursery-manager-inventory-in-get-inventory-in-post';
import { ApiNurseryManagerInventoryInGetInventoryInPost$Params } from '../fn/inventory-in/api-nursery-manager-inventory-in-get-inventory-in-post';
import { apiNurseryManagerInventoryInGetInventoryInPost$Plain } from '../fn/inventory-in/api-nursery-manager-inventory-in-get-inventory-in-post-plain';
import { ApiNurseryManagerInventoryInGetInventoryInPost$Plain$Params } from '../fn/inventory-in/api-nursery-manager-inventory-in-get-inventory-in-post-plain';
import { CreateInventoryInCommandResult } from '../models/create-inventory-in-command-result';
import { DeleteInventoryInCommandResult } from '../models/delete-inventory-in-command-result';
import { GetInventoriesInQueryResult } from '../models/get-inventories-in-query-result';
import { GetInventoryInQueryResult } from '../models/get-inventory-in-query-result';

@Injectable({ providedIn: 'root' })
export class InventoryInService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNurseryManagerInventoryInCreateInventoryInPost()` */
  static readonly ApiNurseryManagerInventoryInCreateInventoryInPostPath = '/api/NurseryManager/InventoryIn/CreateInventoryIn';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryInCreateInventoryInPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryInCreateInventoryInPost$Plain$Response(params?: ApiNurseryManagerInventoryInCreateInventoryInPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateInventoryInCommandResult>> {
    return apiNurseryManagerInventoryInCreateInventoryInPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryInCreateInventoryInPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryInCreateInventoryInPost$Plain(params?: ApiNurseryManagerInventoryInCreateInventoryInPost$Plain$Params, context?: HttpContext): Observable<CreateInventoryInCommandResult> {
    return this.apiNurseryManagerInventoryInCreateInventoryInPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateInventoryInCommandResult>): CreateInventoryInCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryInCreateInventoryInPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryInCreateInventoryInPost$Response(params?: ApiNurseryManagerInventoryInCreateInventoryInPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateInventoryInCommandResult>> {
    return apiNurseryManagerInventoryInCreateInventoryInPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryInCreateInventoryInPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryInCreateInventoryInPost(params?: ApiNurseryManagerInventoryInCreateInventoryInPost$Params, context?: HttpContext): Observable<CreateInventoryInCommandResult> {
    return this.apiNurseryManagerInventoryInCreateInventoryInPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateInventoryInCommandResult>): CreateInventoryInCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerInventoryInDeleteInventoryInDelete()` */
  static readonly ApiNurseryManagerInventoryInDeleteInventoryInDeletePath = '/api/NurseryManager/InventoryIn/DeleteInventoryIn';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryInDeleteInventoryInDelete$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryInDeleteInventoryInDelete$Plain$Response(params?: ApiNurseryManagerInventoryInDeleteInventoryInDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteInventoryInCommandResult>> {
    return apiNurseryManagerInventoryInDeleteInventoryInDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryInDeleteInventoryInDelete$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryInDeleteInventoryInDelete$Plain(params?: ApiNurseryManagerInventoryInDeleteInventoryInDelete$Plain$Params, context?: HttpContext): Observable<DeleteInventoryInCommandResult> {
    return this.apiNurseryManagerInventoryInDeleteInventoryInDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteInventoryInCommandResult>): DeleteInventoryInCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryInDeleteInventoryInDelete()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryInDeleteInventoryInDelete$Response(params?: ApiNurseryManagerInventoryInDeleteInventoryInDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteInventoryInCommandResult>> {
    return apiNurseryManagerInventoryInDeleteInventoryInDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryInDeleteInventoryInDelete$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryInDeleteInventoryInDelete(params?: ApiNurseryManagerInventoryInDeleteInventoryInDelete$Params, context?: HttpContext): Observable<DeleteInventoryInCommandResult> {
    return this.apiNurseryManagerInventoryInDeleteInventoryInDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteInventoryInCommandResult>): DeleteInventoryInCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerInventoryInGetInventoryInPost()` */
  static readonly ApiNurseryManagerInventoryInGetInventoryInPostPath = '/api/NurseryManager/InventoryIn/GetInventoryIn';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryInGetInventoryInPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryInGetInventoryInPost$Plain$Response(params?: ApiNurseryManagerInventoryInGetInventoryInPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryInQueryResult>> {
    return apiNurseryManagerInventoryInGetInventoryInPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryInGetInventoryInPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryInGetInventoryInPost$Plain(params?: ApiNurseryManagerInventoryInGetInventoryInPost$Plain$Params, context?: HttpContext): Observable<GetInventoryInQueryResult> {
    return this.apiNurseryManagerInventoryInGetInventoryInPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryInQueryResult>): GetInventoryInQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryInGetInventoryInPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryInGetInventoryInPost$Response(params?: ApiNurseryManagerInventoryInGetInventoryInPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryInQueryResult>> {
    return apiNurseryManagerInventoryInGetInventoryInPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryInGetInventoryInPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryInGetInventoryInPost(params?: ApiNurseryManagerInventoryInGetInventoryInPost$Params, context?: HttpContext): Observable<GetInventoryInQueryResult> {
    return this.apiNurseryManagerInventoryInGetInventoryInPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryInQueryResult>): GetInventoryInQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerInventoryInGetInventoriesInPost()` */
  static readonly ApiNurseryManagerInventoryInGetInventoriesInPostPath = '/api/NurseryManager/InventoryIn/GetInventoriesIn';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryInGetInventoriesInPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryInGetInventoriesInPost$Plain$Response(params?: ApiNurseryManagerInventoryInGetInventoriesInPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoriesInQueryResult>> {
    return apiNurseryManagerInventoryInGetInventoriesInPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryInGetInventoriesInPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryInGetInventoriesInPost$Plain(params?: ApiNurseryManagerInventoryInGetInventoriesInPost$Plain$Params, context?: HttpContext): Observable<GetInventoriesInQueryResult> {
    return this.apiNurseryManagerInventoryInGetInventoriesInPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoriesInQueryResult>): GetInventoriesInQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryInGetInventoriesInPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryInGetInventoriesInPost$Response(params?: ApiNurseryManagerInventoryInGetInventoriesInPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoriesInQueryResult>> {
    return apiNurseryManagerInventoryInGetInventoriesInPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryInGetInventoriesInPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerInventoryInGetInventoriesInPost(params?: ApiNurseryManagerInventoryInGetInventoriesInPost$Params, context?: HttpContext): Observable<GetInventoriesInQueryResult> {
    return this.apiNurseryManagerInventoryInGetInventoriesInPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoriesInQueryResult>): GetInventoriesInQueryResult => r.body)
    );
  }

}
